var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 72,
    viewBox: "0 0 62 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44 42H42V22H20V42H18V44H46V42H44ZM22 24H40V42H22V24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Window1",
    d: "M27 30H35V27H27V30Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Window2",
    d: "M27 35H35V32H27V35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Window3",
    d: "M27 40H35V37H27V40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 52",
    x: 16,
    y: 56.8491,
    width: 21,
    height: 21,
    transform: "rotate(-45 16 56.8491)",
    fill: "#4A90E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.d7178616f754761f3a8aa7006764b80b.svg";
export { ForwardRef as ReactComponent };